export default {
  EVENT: {
    READY: 'ready',
    CREATE: 'create',
    UPDATE: 'update',
    SUBMIT: 'submit',
    ERROR: 'error',
    MYREWARD: 'myreward' //我的礼品
  },
  HTTP: {
    AREA_JSON: 'getAreaData',
    SAVE_QUESTIONNAIRE: 'save',
    QUESTIONNAIRE_ID: 'getById',
    QUESTIONNAIRE_IDS: 'getByIds',
    SUBMIT_QUESTIONNAIRE: 'submit',
    PUBLISH_QUESTIONNAIRE: 'publish',
    CANCEL_PUBLISH_QUESTIONNAIRE: 'cancelPublish'
  }
}
